/**
 * Pièces justificatives (cahier §10, TODO phase 10, ADR-025).
 * Partagé entre l'API (règles) et les portails (libellés, états affichés).
 */
/** Analyse antivirus : un fichier n'est accessible qu'une fois `clean`. */
export const SCAN_STATUSES = {
    pending: 'Analyse en cours',
    clean: 'Vérifié',
    infected: 'Refusé par l’antivirus',
    error: 'Analyse impossible',
};
/** Contrôle de la pièce par un agent (après dépôt du dossier). */
export const DOCUMENT_REVIEW_STATUSES = {
    pending: 'À vérifier',
    accepted: 'Acceptée',
    rejected: 'Refusée',
};
/** Extensions admises pour chaque format (le contenu réel est vérifié à part). */
export const FILE_EXTENSIONS = {
    pdf: ['pdf'],
    jpg: ['jpg', 'jpeg'],
    png: ['png'],
};
/** États dans lesquels le candidat dépose ou retire librement ses pièces. */
export const DOCUMENT_EDITABLE_STATES = ['draft', 'ready'];
/**
 * Complément demandé : seules les pièces refusées (ou manquantes) peuvent être
 * remplacées ; l'historique conserve la pièce initiale.
 */
export const DOCUMENT_COMPLEMENT_STATES = ['to_complete'];
/** Taille lisible : 1 536 000 → « 1,5 Mo ». */
export function formatFileSize(bytes) {
    if (bytes < 1024)
        return `${bytes} o`;
    if (bytes < 1024 * 1024)
        return `${Math.round(bytes / 1024)} Ko`;
    return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} Mo`;
}
//# sourceMappingURL=documents.js.map